import React, { ReactNode } from 'react';

type Props = {
	children: ReactNode;
	styles?: Record<string, string>;
};

export function WithOverrides(props: Props) {
	const styles = props.styles ?? {};
	return (
		<div
			className="solo-chat-overrides"
			style={{ width: '100%', height: '100%', ...styles }}
		>
			{props.children}
		</div>
	);
}
